import * as repository from '../repository/blacklistRepository';
import { BlacklistEntry } from '../types/blacklist';

class BlacklistServiceError extends Error {
  constructor(message: string, public cause?: Error) {
    super(message);
    this.name = 'BlacklistServiceError';
  }
}

/**
 * 해당 사용자의 거파 명단을 조회합니다. (created_at desc)
 */
export async function getOwnBlacklist(userId: string): Promise<BlacklistEntry[]> {
  try {
    return await repository.findAllOwn(userId);
  } catch (error) {
    throw new BlacklistServiceError('거파 명단 조회 실패', error as Error);
  }
}

/**
 * 거파 등록/재등록합니다. 닉네임은 trim 후 저장(매칭 = trim 정확일치, 스펙 §2·§4).
 * 사유는 trim 후 빈 문자열이면 null 저장.
 */
export async function registerEntry(userId: string, nickname: string, reason: string): Promise<BlacklistEntry> {
  const trimmedNickname = nickname.trim();
  if (!trimmedNickname) {
    throw new BlacklistServiceError('닉네임이 비어 있습니다.');
  }
  const trimmedReason = reason.trim();
  try {
    return await repository.upsertEntry(userId, trimmedNickname, trimmedReason === '' ? null : trimmedReason);
  } catch (error) {
    throw new BlacklistServiceError('거파 등록 실패', error as Error);
  }
}

/**
 * 거파 해제합니다.
 */
export async function unregisterEntry(userId: string, nickname: string): Promise<void> {
  try {
    await repository.removeByNickname(userId, nickname.trim());
  } catch (error) {
    throw new BlacklistServiceError('거파 해제 실패', error as Error);
  }
}
